import { MDBIcon, MDBInput, MDBTextArea } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeDiplomasHandlers from "../../../context/resume/hooks/resume-diplomas-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";
import MyMonthInput from "../../assets/MyMonthInput";
import ReferentialSelect from "../../assets/ReferentialSelect";

export default function DiplomaItem(
    {
        item,
        numberOfItems,
        refEducationLevels,
    }
) {
    const { translations, displayLanguage } = useContext( TranslationContext );
    const { handleChange, handleRemove, handleMoveUp, handleMoveDown } = useResumeDiplomasHandlers();

    return (
        <div>
            <div className="row">
                <div className="d-flex align-items-center justify-content-end">
                    <MDBIcon
                        fas
                        icon="arrow-up"
                        className="m-1"
                        onClick={ () => item.order !== 0 && handleMoveUp( item ) }
                        style={ { cursor: item.order !== 0 ? "pointer" : "default" } }
                        color={ item.order !== 0 ? "" : "muted" }
                        role="button"
                        title="Remonter la formation"
                    />
                    <MDBIcon
                        fas
                        icon="arrow-down"
                        className="m-1"
                        onClick={ () => item.order !== numberOfItems - 1 && handleMoveDown( item ) }
                        style={ { cursor: item.order !== numberOfItems - 1 ? "pointer" : "default" } }
                        color={ item.order !== numberOfItems - 1 ? "" : "muted" }
                        role="button"
                        title="Descendre la formation"
                    />
                    <MDBIcon
                        far
                        icon="trash-alt"
                        className={ `m-1 text-end` }
                        onClick={ () => window.confirm(translations.general.confirmationMessage) && handleRemove( item ) }
                        role="button"
                        size="lg"
                    />
                </div>
                <div className="col-4">
                    <div>
                        <label>{ translations.diplomasSection.schoolNameLabel }</label>
                        <MDBInput
                            type="text"
                            className="form-control-input"
                            value={ item.schoolName || "" }
                            onChange={
                                ( event ) =>
                                    handleChange( { ...item, schoolName: event.target.value } )
                            }
                        />
                    </div>
                    <div className="label-input-container">
                        <label>{ translations.diplomasSection.fromLabel }</label>
                        <MyMonthInput
                            className="transparent-input"
                            value={ item?.from ?? "" }
                            onChange={ ( event ) =>
                                handleChange( { ...item, from: event.target.value } )
                            }
                        />
                        <label>{ translations.diplomasSection.toLabel }</label>
                        <MyMonthInput
                            className={ `transparent-input ${ item.isCurrent ? 'disabled-input' : '' }` }
                            value={ item?.to ?? "" }
                            onChange={ ( event ) =>
                                handleChange( { ...item, to: event.target.value } )
                            }
                            placeholder="Date de fin"
                            min={ new Date( item.from ).setDate( -1 ) }
                            disabled={ item.isCurrent }
                        />
                        <div>
                            <input
                                id={ `currentFormation-${ item.order }` }
                                type="checkbox"
                                onChange={ ( event ) =>
                                    handleChange( { ...item, isCurrent: event.target.checked } )
                                }
                                checked={ item?.isCurrent ?? false }
                            />
                            <label htmlFor={ `currentFormation-${ item.order }` }>
                                { translations.diplomasSection.isCurrentLabel }
                            </label>
                        </div>
                    </div>
                </div>
                <div className="col-8">
                    <div className="mb-2">
                        <label>{ translations.diplomasSection.educationLevelLabel }</label>
                        <ReferentialSelect
                            name="educationLevel"
                            elementId={ `educationLevel-${ item.order }` }
                            firstOption={ translations.diplomasSection.selectEducationLevelLabel }
                            selectedItem={ item.educationLevel?.id || "" }
                            referential={ refEducationLevels }
                            displayLanguage={ displayLanguage }
                            handleChange={ ( event ) =>
                                handleChange( {
                                    ...item,
                                    educationLevel: refEducationLevels.find( el => el.id === Number.parseInt( event.target.value ) )
                                } )
                            }
                        />
                    </div>
                    <div>
                        <label>{ translations.diplomasSection.diplomaTitleLabel }</label>
                        <MDBTextArea
                            type="text"
                            className="form-control-input"
                            value={ item.diplomaTitle || "" }
                            onChange={
                                ( event ) =>
                                    handleChange( { ...item, diplomaTitle: event.target.value } )
                            }
                        />
                    </div>
                </div>
            </div>
            { item.order !== numberOfItems - 1 && (
                <hr className="border border-5"/>
            ) }
        </div>
    );
}
